import Vue from 'vue';

export const expenseDetailsService = {
  async expenseForTimeSheet(timeSheetId) {
    return Vue.axios.post(`/expenses/expense-for-time-sheet`, {
      timeSheetId
    });
  },

  async retrieveExpense(referenceNumber) {
    return Vue.axios.get(`/expenses/${referenceNumber}`).then(response => response.data);
  },

  async retrieveExpenseHistory(referenceNumber) {
    return Vue.axios.get(`/expenses/${referenceNumber}/history`).then(response => response.data);
  },

  async saveExpenseEntries(referenceNumber, action, entries, totalAmount, expenseNote) {
    return Vue.axios.post(`/expenses/${referenceNumber}`, {
      action,
      entries,
      totalAmount,
      expenseNote
    });
  },

  async approveOrRejectExpense(referenceNumber, action, approverComment) {
    return Vue.axios.post(`/expenses/${referenceNumber}`, { action, approverComment });
  },

  async reopenExpense(referenceNumber, action) {
    return Vue.axios.post(`/expenses/${referenceNumber}`, { action });
  },

  async downloadExpensePdf(referenceNumber) {
    const response = await Vue.axios({
      url: `/expenses/${referenceNumber}/pdf`,
      method: 'GET',
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Expense-${referenceNumber}.pdf`);
    document.body.appendChild(link);
    link.click();
  }
};
